import React, { Component } from "react";
import InputField from "./Elements/InputField";
import SubmitFeed from "./Elements/SubmitFeed";


class AirbnbFeed extends Component {
    constructor(props){
        super(props);
        this.state={
            text:'',
            error: false,
            loading: false,
        }
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false });

    onSubmit = () =>{
        const { updateStep } = this.props;
        const { text } = this.state;

        if (!text || text == ""){
            this.setState({ error: true });
        }else {
            this.setState({ error: false,loading:true });

            var obj = {
                networkId: 23,
                moderation: 0,
                feedType: 56,
                airbnb_page_review: text,
                filter: 56,
            }

         updateStep(2, obj, ()=>this.setState({ loading:false }));
    }
}
    render() {
         const { text, error, loading } = this.state;
        return (
            <div className="ob-feed-form-wrapper w-100">
                <div className="selectSource-right mb-3">
                    <div className="position-relative d-flex custom-input ">
                        <span className="hastag d-flex align-items-center">
                            <i className="fab fa-font-awesome-flag"></i>
                        </span>
                        <InputField name={"text"} placeholder="Enter Airbnb URL or ID here.." className="form-control p-3" value={text} onChangeHandler={(e)=>this.onTextChange(e)} />
                    </div>
                    {error && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
                </div>
                <div className="click-next d-flex align-items-center py-2 px-3 rounded justify-content-between">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={!text.trim()} />
                </div>
            </div>
        )
    }
}

export default AirbnbFeed;